export default "__VITE_ASSET__CoWD9NDK__"